webpackJsonp([114276838955818,60335399758886],{

/***/ 92:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Melissa O'Hearn","description":"Melissa O'Hearn is a product and fashion photographer in Seattle, Washington."}}},"layoutContext":{}}

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(183);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(92);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.siteUrlFragmentQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _glamorous = __webpack_require__(5);
	
	var _components = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var data = _ref.data,
	      children = _ref.children;
	  var _data$site$siteMetada = data.site.siteMetadata,
	      pageTitle = _data$site$siteMetada.title,
	      description = _data$site$siteMetada.description;
	
	  return React.createElement(
	    _glamorous.Div,
	    {
	      css: {
	        display: 'flex',
	        flexDirection: 'column',
	        minHeight: '100vh',
	        height: '100%'
	      }
	    },
	    React.createElement(_components.DefaultHead, { pageTitle: pageTitle, description: description }),
	    React.createElement(_components.Header, { title: data.site.siteMetadata.title }),
	    React.createElement(
	      _glamorous.Main,
	      { flex: '1' },
	      children()
	    ),
	    React.createElement(_components.Footer, null)
	  );
	};
	exports.default = DefaultLayout;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var siteUrlFragmentQuery = exports.siteUrlFragmentQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-08719db683c58122c1bb.js